// src/components/Seo.jsx
import { useEffect } from "react";

function setOrUpdateTag(tagName, attrs = {}, uniqueKey = "") {
  const selector = Object.entries(attrs)
    .map(([k, v]) => `[${k}="${String(v).replace(/"/g, '\\"')}"]`)
    .join("");
  let el = document.head.querySelector(`${tagName}${selector}`);
  if (!el) {
    el = document.createElement(tagName);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  if (uniqueKey) el.dataset.seoKey = uniqueKey;
  return el;
}

export default function Seo({
  title,
  description,
  canonical,
  openGraph = {},
  twitter = {},
  jsonLd = [],
}) {
  useEffect(() => {
    const toCleanup = [];

    if (title) document.title = title;
    if (description) {
      toCleanup.push(setOrUpdateTag("meta", { name: "description", content: description }, "desc"));
    }
    if (canonical) {
      toCleanup.push(setOrUpdateTag("link", { rel: "canonical", href: canonical }, "canonical"));
    }

    // Open Graph
    const og = {
      "og:type": openGraph.type || "website",
      "og:title": openGraph.title || title,
      "og:description": openGraph.description || description,
      "og:url": openGraph.url || canonical,
      "og:site_name": openGraph.siteName,
      "og:image": openGraph.image,
    };
    Object.entries(og).forEach(([p, v]) => {
      if (!v) return;
      toCleanup.push(setOrUpdateTag("meta", { property: p, content: v }, p));
    });

    // Twitter
    const tw = {
      "twitter:card": twitter.card || "summary_large_image",
      "twitter:title": twitter.title || title,
      "twitter:description": twitter.description || description,
      "twitter:image": twitter.image || openGraph.image,
    };
    Object.entries(tw).forEach(([n, v]) => {
      if (!v) return;
      toCleanup.push(setOrUpdateTag("meta", { name: n, content: v }, n));
    });

    // JSON-LD
    jsonLd.forEach((obj, i) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.text = JSON.stringify(obj);
      s.dataset.seoKey = `jsonld-${i}`;
      document.head.appendChild(s);
      toCleanup.push(s);
    });

    return () => {
      toCleanup.forEach((el) => el && el.remove && el.remove());
    };
  }, [title, description, canonical, openGraph, twitter, jsonLd]);

  return null;
}
